import { Close, ReceiptLongOutlined } from '@mui/icons-material';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from '../../../services/api';
import moment from 'moment';

const fmtMoneda = (valor) => `$${(valor || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}`;

const CierreZetaModal = ({ open, onClose, eventoId, cajaId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [cierre, setCierre] = useState(null);

  useEffect(() => {
    if (open && eventoId && cajaId) {
      fetchCierre();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, eventoId, cajaId]);

  const fetchCierre = async () => {
    setLoading(true);
    setError(null);
    setCierre(null);
    try {
      const res = await api.caja.getCierreZeta(eventoId, cajaId);
      if (res.status === "success") {
        setCierre(res.data);
      } else {
        setError(res.message || "No se pudo obtener el cierre");
      }
    } catch (e) {
      setError("Error al obtener el cierre");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setCierre(null);
    setError(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center" gap={1}>
            <ReceiptLongOutlined sx={{ color: "#5656FF" }} />
            <Typography variant="h6" sx={{ fontFamily: "Bricolage Grotesque", color: "#0b0062", fontWeight: 600 }}>
              Reporte Z {cierre?.caja ? `- ${cierre.caja}` : ""}
            </Typography>
          </Box>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        {loading && (
          <Box display="flex" justifyContent="center" alignItems="center" sx={{ py: 6 }}>
            <CircularProgress size={28} />
          </Box>
        )}

        {!loading && error && (
          <Typography sx={{ color: "#d32f2f", textAlign: "center", py: 4 }}>
            {error}
          </Typography>
        )}

        {!loading && cierre && (
          <Box>
            <Box sx={{ mb: 2, p: 2, backgroundColor: "#f5f5f5", borderRadius: 2, border: "1px solid #e0e0e0" }}>
              <Typography sx={{ fontWeight: 600, color: "#0b0062" }}>{cierre.vendedor}</Typography>
              <Typography sx={{ color: "#666", fontSize: "14px" }}>{cierre.evento}</Typography>
              <Typography sx={{ color: "#666", fontSize: "13px", mt: 1 }}>
                Período: {moment(cierre.periodo_desde).format("DD/MM/YYYY HH:mm")} — {moment(cierre.periodo_hasta).format("DD/MM/YYYY HH:mm")}
              </Typography>
            </Box>

            <Typography sx={{ fontWeight: 600, color: "#0b0062", mb: 1 }}>Por medio de pago</Typography>
            {cierre.por_medio_pago && cierre.por_medio_pago.length > 0 ? (
              cierre.por_medio_pago.map((m) => (
                <Box key={m.medio_pago} sx={{ display: "flex", justifyContent: "space-between", py: 0.5 }}>
                  <Typography sx={{ fontSize: "14px", textTransform: "capitalize" }}>
                    {m.medio_pago} ({m.cantidad})
                  </Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>{fmtMoneda(m.monto)}</Typography>
                </Box>
              ))
            ) : (
              <Typography sx={{ fontSize: "14px", color: "#999" }}>Sin ventas en el período</Typography>
            )}

            <Divider sx={{ my: 2 }} />

            <Typography sx={{ fontWeight: 600, color: "#0b0062", mb: 1 }}>Por tarifa</Typography>
            {cierre.por_tarifa && cierre.por_tarifa.length > 0 ? (
              cierre.por_tarifa.map((t) => (
                <Box key={t.idtarifa} sx={{ display: "flex", justifyContent: "space-between", py: 0.5 }}>
                  <Typography sx={{ fontSize: "14px" }}>{t.concepto} x{t.cantidad}</Typography>
                  <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>{fmtMoneda(t.importe)}</Typography>
                </Box>
              ))
            ) : (
              <Typography sx={{ fontSize: "14px", color: "#999" }}>Sin ventas en el período</Typography>
            )}

            <Divider sx={{ my: 2 }} />

            <Box sx={{ display: "flex", justifyContent: "space-between", py: 0.5 }}>
              <Typography sx={{ fontSize: "14px" }}>Total operaciones</Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>{cierre.total_operaciones}</Typography>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", py: 0.5 }}>
              <Typography sx={{ fontSize: "14px" }}>Total vendido</Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>{fmtMoneda(cierre.total_ventas)}</Typography>
            </Box>

            <Box sx={{ mt: 2, p: 2, backgroundColor: "#eef0ff", borderRadius: 2 }}>
              <Typography sx={{ fontSize: "16px", fontWeight: 600, color: "#0b0062" }}>
                Efectivo a rendir: {fmtMoneda(cierre.efectivo_a_rendir)}
              </Typography>
            </Box>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={handleClose}
          sx={{
            border: "1px solid #ccc",
            color: "#666",
            padding: "8px 16px",
            borderRadius: "4px",
            width: "100%"
          }}
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CierreZetaModal;
